import React, { useEffect, useState } from 'react';
import Button from '../../../../../../components/Forms/Button';
import Submission from '../Submission';
import { Container } from './styles';
import MyPapers from '../MyPapers';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import { authTitle, defaultProjectHash, supportNumber } from '../../../../../../config';
import Whatsapp from '../../../../../../components/Whatsapp';
import UpdateProfile from '../../../../../../components/FormContainerUpdate';
import api from '../../../../../../services/api';
import { cpf } from './verify';
import { useAuth } from '../../../../../../hooks/Auth';

interface IParams {
  tab: string;
}

const CientificListSubmission: React.FC = () => {
  const [type, setType] = useState('profile');
  const { projectHash = defaultProjectHash } = useParams<Record<string, any>>();
  const [submissions, setSubmissions] = useState<Array<Record<string, any>>>([])
  const { user } = useAuth();
  const [validTab, setValidTab] = useState({
    home: '',
    submeter: 'submeter'
  });

  const load = async () => {

    const submission = await api.get(`/list-submission-selective/${projectHash}`);

    if (submission?.data?.rows?.length > 0) {
      setSubmissions(submission?.data?.rows?.reverse());
    }

  }

  useEffect(() => {
    load();
  }, [])

  const indexCPF = cpf.findIndex(c => c === user?.document_number);
  return (
    <>

      <Container >

        <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', flexWrap: 'wrap', justifyContent: 'center', padding: '10px' }}>
          <h2 style={{ color: '#333' }}>Selecione a categoria</h2>
          {submissions?.map(sub => {

            if (indexCPF < 0 && sub.hash === '36-simposio-de-oftalmologia-do-hcpa') { return <></>; }
            if (indexCPF >= 0 && sub.hash === 'simposio-ciencias-para-um-mundo-em-movimento') { return <></> }

            return <a href={`/trabalhos/submeter-trabalho/${sub?.hash}`}><button className='defaultButtonReverse' style={{ height: 'auto', width: '100%', minWidth: '300px', maxWidth: '300px' }}>{sub.title}</button></a>
          })}
        </div>


      </Container>
    </>
  );
};
export default CientificListSubmission;
